import React, { useCallback, useState } from "react"
import { SelectSurveyModel } from "../../../../pages/chat-room/components/live/room/pages/chat/components/modals/create-survey/components/select-survey-type"
import { SurveyModel } from "../../../../rpcs/dist/ChatRoomRPC"
import { Modal, ModalDescription, ModalTitle } from "../../../parts/modal"
import {
  CreateScaleSurvey,
  ICreateScaleSurveyProps,
} from "../../surbey/create/create-scale-survey"
import {
  CreateSelectSurvey,
  ICreateSelectSurveyProps,
} from "../../surbey/create/create-select-survey"

interface IProps {
  onClose: () => void
  onSubmit: (props: ICreateSelectSurveyProps | ICreateScaleSurveyProps) => void
}

export const SurveyModal = (props: IProps) => {
  const [model, setModel] = useState<SurveyModel | null>(null)
  const resetType = useCallback(() => setModel(null), [])

  const onSelectType = useCallback((t: SurveyModel | null) => {
    setModel(t)
  }, [])

  if (model === SurveyModel.Select) {
    return (
      <Modal onBackgroundClick={props.onClose}>
        <ModalTitle>アンケートを設定してください</ModalTitle>
        <ModalDescription>
          <CreateSelectSurvey onBack={resetType} onSubmit={props.onSubmit} />
        </ModalDescription>
      </Modal>
    )
  }

  if (model === SurveyModel.Scale) {
    return (
      <Modal onBackgroundClick={props.onClose}>
        <ModalTitle>アンケートを設定してください</ModalTitle>
        <ModalDescription>
          <CreateScaleSurvey onBack={resetType} onSubmit={props.onSubmit} />
        </ModalDescription>
      </Modal>
    )
  }

  return <SelectSurveyModel onClose={props.onClose} onSelect={onSelectType} />
}
